import type { CustomerRole } from '@misumi/shared'

/**
 * Display labels for the four `CustomerRole` values (`@misumi/shared`,
 * `CUSTOMER_ROLES`). Kept in one place so the invite-role `<select>`
 * (`InviteUserForm`) and every table that renders a member/invite/request's
 * role (`InvitationsTable`, `JoinRequestsTable`) render identical copy.
 */
export const ROLE_LABELS: Record<CustomerRole, string> = {
  buyer: 'Buyer',
  engineer: 'Engineer',
  purchaser: 'Purchaser',
  account_admin: 'Account admin',
}

export function roleLabel(role: CustomerRole): string {
  return ROLE_LABELS[role]
}
